var map = {
	"./adult/nn/skrivehastighet-data.json": 782,
	"./adult/no/skrivehastighet-data.json": 783,
	"./adult/se/skrivehastighet-data.json": 784,
	"./youth/de/skrivehastighet-data.json": 785,
	"./youth/nn/skrivehastighet-data.json": 786,
	"./youth/no/skrivehastighet-data.json": 787,
	"./youth/se/skrivehastighet-data.json": 788
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 113;